
import React from 'react';
import { Badge } from "@/components/ui/badge";

type DifficultyLevel = 'Easy' | 'Medium' | 'Hard' | 'Expert';

interface DifficultyProps {
  level: DifficultyLevel;
}

export function Difficulty({ level }: DifficultyProps) {
  const getColorForDifficulty = (difficulty: DifficultyLevel) => {
    switch (difficulty) {
      case 'Easy':
        return 'bg-green-500/20 text-green-500';
      case 'Medium':
        return 'bg-yellow-500/20 text-yellow-500';
      case 'Hard':
        return 'bg-orange-500/20 text-orange-500';
      case 'Expert':
        return 'bg-red-500/20 text-red-500';
      default:
        return 'bg-primary/20 text-primary';
    }
  };

  return (
    <Badge variant="outline" className={`${getColorForDifficulty(level)}`}>
      {level}
    </Badge>
  );
}
